// extracted by mini-css-extract-plugin
export default {"flexbox":"Home_flexbox__xcfFj"};